// extracted by mini-css-extract-plugin
export default {"submitBtn":"ForgotPasswordForm_submitBtn__0cgKo","disabled":"ForgotPasswordForm_disabled__CYvqJ","note":"ForgotPasswordForm_note__33mtA"};